<template>
  <div class="navbar">
    <div class="base-warpper header-config">
      <div class="left">
        <h1 class="logo">
          <!-- eslint-disable-next-line -->
          <img :src="appConfig.logo" alt="" height="30" />
        </h1>
        <h2>{{ appConfig.site }}</h2>
        <el-menu
          :default-active="activeMenu"
          class="el-menu-horizontal"
          mode="horizontal"
          :background-color="variables.horizontalMenuBg"
          :unique-opened="false"
          :text-color="variables.horizontalMenuText"
          :active-text-color="variables.horizontalMenuText"
          @select="handleSelect"
        >
          <template v-for="item in route">
            <el-menu-item v-if="!item.meta?.hidden" :key="item.path" :disabled="isForce" :route="item" :index="resolvePath(item.path)">{{ item.title }}</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="right">
        <el-avatar size="large" :src="userInfo.headimg || userInfo.headimgUrl" fit="cover" icon="el-icon-user-solid" />
        <el-dropdown @command="handleClicks">
          <span class="el-dropdown-link"> {{ name }}<i class="el-icon-arrow-down el-icon--right" /> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="UserCenter" :disabled="isForce">个人中心</el-dropdown-item>
            <el-dropdown-item command="logOut">安全退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { isExternal } from '@/utils/validate'
import variables from '@/utils/variables'
import defaultSettings from '@/settings'
import path from 'path'
import { returnFullPath } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      activeIndex: 'index',
      isLogin: false
    }
  },
  computed: {
    systemSide() {
      return defaultSettings.side
    },
    variables() {
      return variables
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (path === '/dashboard') return '/'
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return '/' + path.split('/')[1]
    },
    route() {
      return this.$router.options.routes.filter(v => !v.hidden)
    },
    basePath() {
      if (this.activeMenu === '/') return ''
      return this.activeMenu.split('/')[1]
    },
    isForce() {
      const { name } = this.$route
      if (['forceAssessment'].includes(name)) {
        return true
      }
      return false
    },
    ...mapGetters(['token', 'name', 'userInfo', 'appConfig'])
  },
  methods: {
    returnFullPath,
    handleSelect(path) {
      const name = this.route.filter(v => v.path === path)[0].name

      this.$router.push(path)
      this.$store.commit('app/CHANGE_CURRENT_ROUTER_KEY', name)
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    handleClicks(key) {
      switch (key) {
        case 'UserCenter':
          this.$router.push({ name: key })
          break
        case 'logOut':
          this.$store.dispatch('user/Logout')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-menu.el-menu--horizontal) {
  border-bottom: none;
}
:deep(.el-menu--horizontal > .el-menu-item) {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  padding: 0 8px;
  // margin-left: 10px;
}
:deep(.el-avatar > img) {
  width: 100%;
}
.navbar {
  width: 100%;
  height: var(--head-height);
  background-color: var(--theme-color);
}
.el-menu {
  background-color: var(--theme-color);
}
.header-config {
  height: var(--head-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}
h2 {
  color: #fff;
  margin: 0 20px;
  font-size: 16px;
}
.left,
.right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  h2 {
    font-size: 18px;
    font-weight: 500;
  }
}
.logo {
  width: 328px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 100%;
  }
}
.el-dropdown {
  margin-left: 20px;
  .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }
}
</style>
